import { useState } from "react";
import { toast } from "sonner";
import { MessageSquareHeart } from "lucide-react";
import api, { customerAuth } from "../lib/api";
import { Stars } from "./Stars";

export function ReviewForm({ productId, productName, existing, onSaved }) {
  const [open, setOpen] = useState(false);
  const [rating, setRating] = useState(existing?.rating || 0);
  const [text, setText] = useState(existing?.text || "");
  const [name, setName] = useState(existing?.name || "");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!rating) return toast.error("Pick a star rating");
    setBusy(true);
    try {
      const r = await api.post("/library/reviews", { product_id: productId, rating, text, name }, customerAuth());
      toast.success("Thank you — your testimony is live");
      onSaved?.(r.data); setOpen(false);
    } catch (err) { toast.error(err?.response?.data?.detail?.[0]?.msg || err?.response?.data?.detail || "Could not save"); }
    finally { setBusy(false); }
  };

  if (!open) {
    return (
      <button data-testid={`review-open-${productId}`} onClick={() => setOpen(true)} className="inline-flex items-center gap-1 text-sm text-[#0a192f] hover:text-[#d4af37] font-semibold mt-2 ml-3">
        <MessageSquareHeart className="w-3.5 h-3.5" /> {existing ? `Edit review (${existing.rating}★)` : "Rate & review"}
      </button>
    );
  }
  return (
    <form onSubmit={submit} className="mt-3 border border-[#e5e5e5] bg-[#fdfbf7] p-4" data-testid={`review-form-${productId}`}>
      <div className="text-sm font-semibold text-[#0a192f]">How did <em>{productName}</em> meet you?</div>
      <div className="mt-2"><Stars value={rating} size="w-6 h-6" onChange={setRating} testId={`review-rating-${productId}`} /></div>
      <textarea data-testid={`review-text-${productId}`} rows={3} required minLength={3} value={text} onChange={(e) => setText(e.target.value)} placeholder="A sentence or two about what this meant to you…" className="mt-3 w-full border border-[#e5e5e5] px-3 py-2 text-sm outline-none focus:border-[#0a192f]" />
      <input data-testid={`review-name-${productId}`} value={name} onChange={(e) => setName(e.target.value)} placeholder="Display name (optional)" className="mt-2 w-full border border-[#e5e5e5] px-3 py-2 text-sm outline-none focus:border-[#0a192f]" />
      <div className="flex gap-2 mt-3">
        <button data-testid={`review-submit-${productId}`} disabled={busy} className="btn-navy text-sm py-2 disabled:opacity-50">{busy ? "Saving…" : "Post review"}</button>
        <button type="button" onClick={() => setOpen(false)} className="btn-ghost text-sm py-2">Cancel</button>
      </div>
    </form>
  );
}
